import React, { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@material-ui/core';
import { Pergunta } from 'api/Assessor/duvidas';
import { getDateFullTime } from 'utils/DateUtils';
import {
  ReplyIcon,
  EditIcon,
  PublicIcon,
  InvertedChevronIcon,
  SecurityIcon,
} from 'components/Icons';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import Visibility from './Visibility';
import ChatContext from './ChatContext';
import useStyle from './style';

export default function (props: Pergunta) {
  const { t } = useTranslation();
  const classes = useStyle();
  const { conversaAtual, auth } = useContext(MensagensContext);
  const { duvidaAtual, setDuvida } = useContext(ChatContext);
  const [coords, setCoords] = useState<DOMRect>();
  const [openOptions, setOpenOptions] = useState<boolean>(false);

  const respondida = useMemo(() => {
    if (props.resposta !== undefined) {
      return classes.respondida;
    }
  }, [props, classes]);

  const isCurrent = useMemo(() => {
    if (duvidaAtual?.idPergunta === props.idPergunta) {
      return true;
    }
    return false;
  }, [duvidaAtual, props]);

  return (
    <div className={[classes.duvida, respondida].join(' ').trim()}>
      <Typography className={classes.duvidaData}>
        {getDateFullTime(new Date(props.dataPergunta))} - {conversaAtual!.nome}
      </Typography>
      <div className={classes.pergunta}>
        <Typography className={classes.perguntaText}>{props.pergunta}</Typography>
        {auth?.alterarSituacao && (
          <React.Fragment>
            <Button
              variant="contained"
              className={
                props.flgPublica ? classes.perguntaPublic : classes.perguntaPrivate
              }
              startIcon={
                props.flgPublica ? (
                  <PublicIcon className={classes.buttonIcon} />
                ) : (
                  <SecurityIcon className={classes.buttonIcon} />
                )
              }
              endIcon={<InvertedChevronIcon className={classes.buttonIcon} />}
              onClick={e => {
                setCoords(e.currentTarget.getBoundingClientRect());
                setOpenOptions(true);
              }}
            >
              {props.flgPublica
                ? t('AssessorMensagens.public')
                : t('AssessorMensagens.private')}
            </Button>
            <Visibility
              coords={coords}
              isOpen={openOptions}
              handleClose={() => setOpenOptions(false)}
              isPublic={props.flgPublica}
              idDuvida={props.idPergunta}
            />
          </React.Fragment>
        )}
      </div>
      {!props.resposta && auth?.responder && (
        <Button
          variant="contained"
          className={classes.responder}
          startIcon={<ReplyIcon className={classes.buttonIcon} />}
          disabled={isCurrent}
          onClick={() => setDuvida(props)}
        >
          {t('AssessorMensagens.answer')}
        </Button>
      )}
      {props.resposta && props.dataResposta && (
        <React.Fragment>
          <Typography className={classes.respostaData}>
            {getDateFullTime(new Date(props.dataResposta))} -{' '}
            {props.usuarioResposta}
          </Typography>
          <div className={classes.resposta}>
            <Typography className={classes.respostaText}>
              {props.resposta}
            </Typography>
            {auth?.responder && (
              <Button
                variant="contained"
                color="primary"
                className={classes.editarResposta}
                startIcon={<EditIcon className={classes.buttonIcon} />}
                onClick={() => setDuvida(props)}
                disabled={isCurrent}
              >
                {t('edit')}
              </Button>
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
}
